import AbstractSegment from './AbstractSegment';
import subjectScores from '../../constants/subject-scores';



const subjectDefault = {
  type     : 'direct',
  state    : 'pending',
  direct   : null,
  selfcheck: null,
};



export default class Scores extends AbstractSegment {
  requireYear = true;
  name = 'scores';
  _perCache = null;

  static STATES = [
    {id: '0', name: 'pending' },
    {id: '1', name: 'selected'},
    {id: '2', name: 'fixed'   },
  ];

  static TYPES = [
    {id: '0', name: 'direct'   },
    {id: '1', name: 'selfcheck'},
  ];

  static getStateNameById(id) { return this.STATES.find(state => state.id === id).name }
  static getStateIdByName(name) { return this.STATES.find(state => state.name === name).id }
  static getTypeNameById(id) { return this.TYPES.find(type => type.id === id).name }
  static getTypeIdByName(name) { return this.TYPES.find(type => type.name === name).id }



  /**
   * 得点率を取得する
   * 科目の完了状態等を問わず、セグメントに保持されていれば全て加算対象
   */
  getTotalPer() {
    if (this._perCache !== null) return this._perCache;

    const subjects = this.getSubjects();

    let total    = 0;
    let totalMax = 0;

    for (let id in subjects) {
      const define = subjectScores[id];
      if (!define) continue;

      const score = subjects[id][subjects[id].type];
      if (score !== null) {
        total += score;
        totalMax += define.max;
      }
    }

    this._perCache = totalMax === 0 ? 0 : Math.round(total / totalMax * 100);
    return this._perCache;
  }



  onEraseAfter() {
    this._perCache = null;
  }



  /**
   * 複数の科目情報をcookieに保存する
   */
  putSubjects(subjects = {}) {
    const targets = this.getSubjects();

    for (let id in subjects) {
      if (!subjectScores[id]) continue;
      const subject = subjects[id];
      const target  = targets[id] || Object.assign({id: id}, subjectDefault);
      targets[id] = Object.assign(target, subject);
    }

    this.storeSubjects(targets);
  }



  /**
   * データを同期して同期完了後のデータを取得する
   *   DNサイトでローカルストレージを更新するため、
   *   もしくはセグメントに未登録のローカルストレージの科目を保存するために利用する
   *
   *   元データの科目IDがセグメントになければ上書き
   *   セグメント側にデータがあった場合には、変更のあったキーのみを返却する
   *   受け取り側には変更のあった科目、キーのみがレスポンスされるので
   *   ローカルストレージに同期を行う
   */
  syncAndGetUpdateData(subjects) {
    const targets = this.getSubjects();
    const result  = {};

    let needUpdateSegment = false;

    for (let id in subjects) {
      if (!subjectScores[id]) continue;
      const subject = subjects[id];
      const target  = targets[id];

      if (target) {
        let updateValues = {};
        for (let key in target) {
          if (target[key] !== subject[key]) {
            updateValues[key] = target[key];
          }
        }
        if (Object.keys(updateValues).length) result[id] = updateValues;
      } else {
        needUpdateSegment = true;
        targets[id] = Object.assign({}, subject);
      }
    }

    if (needUpdateSegment) this.storeSubjects(targets);
    return result;
  }



  /**
   * 複数の科目情報のハッシュを保存する
   */
  storeSubjects(subjects) {
    this._perCache = null;
    const cookieString = this.jsonToCookieString(subjects);
    this._set(cookieString);
  }



  /**
   * cookie文字列中の全科目情報をjsonで取得する
   */
  getSubjects() {
    return this.cookieStringToJson(this._get(''));
  }



  /**
   * 複数の科目情報のハッシュをcookie用文字列にパースして返却する
   */
  jsonToCookieString(subjects) {
    const subjectStrings = [];
    for (let id in subjects) {
      subjectStrings.push(this.jsonToSubjectString(subjects[id]));
    }
    return subjectStrings.join(',');
  }



  /**
   * 科目1つ分のjsonをcookie文字列にパースして返却する
   *   【科目ID】_【種別】_【状態】_【点数入力】_【解答入力】
   */
  jsonToSubjectString(subject) {
    const type      = this.constructor.getTypeIdByName(subject.type);
    const state     = this.constructor.getStateIdByName(subject.state);
    const direct    = subject.direct    === null ? 'n' : subject.direct;
    const selfcheck = subject.selfcheck === null ? 'n' : subject.selfcheck;

    return `${subject.id}_${type}_${state}_${direct}_${selfcheck}`;
  }



  /**
   * cookie文字列をjsonにパースして返却する
   */
  cookieStringToJson(str) {
    const subjects = {};

    let subjectStrings = str.split(',');
    subjectStrings = subjectStrings.length === 1 && subjectStrings[0] === '' ? [] : subjectStrings;

    subjectStrings.forEach(subjectString => {
      const subject = this.subjectStringToJson(subjectString);
      subjects[subject.id] = subject;
    });
    return subjects;
  }



  /**
   * cookie文字列中の科目1つ分の文字列をjsonにパースして返却する
   *   【科目ID】_【種別】_【状態】_【点数入力】_【解答入力】
   */
  subjectStringToJson(str) {
    let tmp = str.split('_');
    tmp = tmp.length === 1 && tmp[0] === '' ? [] : tmp;

    if (tmp.length < 5) return;

    const direct    = tmp[3] === 'n' ? null : parseInt(tmp[3], 10);
    const selfcheck = tmp[4] === 'n' ? null : parseInt(tmp[4], 10);

    return {
      id       : tmp[0],
      type     : this.constructor.getTypeNameById(tmp[1]),
      state    : this.constructor.getStateNameById(tmp[2]),
      direct   : isNaN(direct   ) ? null : direct,
      selfcheck: isNaN(selfcheck) ? null : selfcheck,
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/bc-segments/segments/Scores.js